import { LeaderboardMetricId } from 'app/features/contest/models/contest-template.models';
import { ContestRankingMode } from './api/contest-api.types';

export const REFRESH_INTERVAL_MS: number = 10000;

export const METRIC_MODE_BY_ID: Record<LeaderboardMetricId, ContestRankingMode> = {
  chrono: 'top_ranking_chrono',
  distance: 'top_ranking_distance',
  ppr: 'top_ranking_ppr',
  wpk: 'top_ranking_wpk',
};
